import { APIClient } from '@frontend/api-utils';
import { AccessKey } from '@frontend/identification/types';

export class IdentificationAccessKeyClient extends APIClient {
    public static readonly endpoint = '/identification-api/v1';

    public static async postGenerateAccessKey(): Promise<AccessKey> {
        const response = await this.post(`${this.endpoint}/access-keys`);
        return await this.handleResponse<AccessKey>(response);
    }
}
